
import User from './modules/UserApi'
import Company from './modules/CompanyApi'
import CompanyFinancial from './modules/CompanyFinancialApi'
import Event from './modules/EventApi'
import Movement from './modules/MovementApi'
import DashCounter from './modules/DashCounterApi'
import Role from './modules/RoleApi'
import Dashboard from './modules/DashboardApi'
import Extract from './modules/ExtractApi'
import EventClient from './modules/EventClientApi'
import EventDetail from './modules/EventDetailApi'
import EventExpense from './modules/EventExpenseApi'
import Activity from './modules/ActivityApi'
import Negotiation from './modules/NegotiationApi'
import EventContact from './modules/EventContactApi'
import SuperAdminControl from './modules/SuperAdminControlApi'


export default {
  User,
  Company,
  CompanyFinancial,
  Event,
  Movement,
  DashCounter,
  Role,
  Dashboard,
  Extract,
  EventClient,
  EventDetail,
  EventExpense,
  Activity,
  Negotiation,
  EventContact,
  SuperAdminControl,
}